<template>
  <v-row class="my-1">
    <v-col class="py-0">
      <v-text-field
        v-bind="{ ...$attrs }"
        @input="v => handleUpdate({ value: v })"
        :value="pValue"
        :label="lgLabel"
        counter="1024"
        maxLength="1024"
        dense
        outlined
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { max1024 } from "@/utils/validator"

export default {
  name: "TextField",
  props: {
    label: { type: String, default: "" },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ value: "" }]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    pValue: {
      get() {
        return this.values[0].value
      }
    }
  },
  data() {
    return {
      rules: [max1024]
    }
  },
  methods: {
    handleUpdate(updateObj) {
      const oldObj = { id: 0, value: this.value }
      const newValue = [{ ...oldObj, ...updateObj }]
      this.$emit("input", newValue)
    }
  }
}
</script>
